import axios from 'axios'
import { CMSApiResponseBody } from 'types/cms/request'
import { Language } from 'types/language'
import { CmsEncyclopediaSubcategory } from 'types/cms/collection-types'

/**
 * Get the encyclopedia subcategories from the CMS
 *
 * @param {Language} locale
 * @returns {Promise<CmsEncyclopediaSubcategory[]>}
 */
const getEncyclopediaSubcategories = async (locale: Language = Language.DUTCH): Promise<CmsEncyclopediaSubcategory[]> => {
  try {
    const { data } = await axios.get<CMSApiResponseBody<CmsEncyclopediaSubcategory[]>>(
      `${process.env.CMS_API_URL}/encyclopedia-sub-categories?locale=${locale}`
    )

    return data.data ?? []
  } catch (_) {
    return []
  }
}

export default getEncyclopediaSubcategories
